import * as Sentry from "@sentry/vue";
import Vue from "vue";

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;

if (dsn) {
  const environment =
    document.querySelector('meta[name="app-env"]')?.content || "staging";

  Sentry.init({
    Vue,
    dsn,
    environment,
    denyUrls: [
      /graph\.facebook\.com/i,
      /cdn\.iubenda\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    initialScope: { tags: { platform: "frontend", app: "adcontrol" } },
  });
}
